import { useTranslation } from "react-i18next";
import { ListNavLayout } from "@/components/ListNavLayout";
import { useAdminNav } from "./adminNav";
import { RequirePlatformAdmin } from "./RequirePlatformAdmin";

/** /admin/*: the platform-admin gate plus the grouped list → detail frame. */
export function AdminLayout() {
  const { t } = useTranslation("admin");
  const groups = useAdminNav();
  return (
    <RequirePlatformAdmin>
      <ListNavLayout
        basePath="/admin"
        title={t("title")}
        subtitle={t("subtitle")}
        groups={groups}
        defaultTo="/admin/users"
        aria-label={t("nav.label")}
      />
    </RequirePlatformAdmin>
  );
}
